var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 202.1,
    height: 202.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.89,
    y: 309.89,
    style: {
      fill: "#41479B"
    },
    width: 202.1,
    height: 202.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.89,
    style: {
      fill: "#FF4B55"
    },
    width: 202.1,
    height: 202.1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 309.89,
    style: {
      fill: "#FF4B55"
    },
    width: 202.1,
    height: 202.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64B496"
    },
    d: "M248.264,294.419c0,0,8.05,2.947,7,13.053l3.254-0.06c0,0-2.053-11.678-3.75-13.078   C253.072,292.934,248.264,294.419,248.264,294.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64B496"
    },
    d: "M256.334,292.859c-3.413,0-9.383-0.004-15.658-1.699c1.399-1.457,3.332-4.389,3.332-9.504   c0-8.01-5.519-2.9-5.519-2.9s-3.63,3.053-1.435,11.219c-2.141-0.816-4.262-1.87-6.288-3.218c1.26-1.581,3.771-5.267,5.232-11.108   c0,0-9.197-1.818-11.713,5.107c-1.541-1.956-2.86-4.155-3.961-6.589c2.364,0.029,5.662-1.531,5.662-10.533   c0,0-6.006,0.009-7.612,5.22c-0.631-2.177-1.113-4.511-1.467-6.978c2.398,0.696,8.598,1.195,8.598-12.259   c0,0-7.444,0.013-9.168,6.607c-0.094-1.686-0.131-3.43-0.114-5.228c3.614-1.889,8.604-6.052,8.084-14.592   c0,0-3.433,0.778-6.579,3.417c0.62-3.237,0.363-7.977-4.601-11.931c0,0-4.563,8.074,2.101,14.629   c-0.579,0.816-1.084,1.743-1.502,2.774c-1.497-2.28-3.899-4.4-7.765-5.689c0,0-1.781,10.815,8.316,15.339   c0.239,6.316,1.228,11.895,2.924,16.748c-2.891-2.549-5.233-6.055-5.233-6.055c0-12.015-9.849-12.318-9.849-12.318   c-1.839,13.714,8.301,14.269,8.301,14.269l5.553,6.059c-12.015-2.002-12.015,8.01-12.015,8.01   c8.01,2.002,12.015-2.002,12.015-2.002l4.332,2.226c-7.683,0.224-10.339,7.786-10.339,7.786c9.657,1.609,16.717-0.659,19.12-1.613   c9.726,6.8,21.712,6.809,27.248,6.809V292.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64B496"
    },
    d: "M255.652,292.859c3.414,0,9.383-0.004,15.658-1.699c-1.399-1.457-3.332-4.389-3.332-9.504   c0-8.01,5.519-2.9,5.519-2.9s3.63,3.053,1.435,11.219c2.141-0.816,4.262-1.87,6.288-3.218c-1.26-1.581-3.771-5.267-5.232-11.108   c0,0,9.197-1.818,11.713,5.107c1.541-1.956,2.86-4.155,3.961-6.589c-2.364,0.029-5.662-1.531-5.662-10.533   c0,0,6.006,0.009,7.612,5.22c0.631-2.177,1.113-4.511,1.467-6.978c-2.398,0.696-8.598,1.195-8.598-12.259   c0,0,7.444,0.013,9.168,6.607c0.094-1.686,0.131-3.43,0.114-5.228c-3.614-1.889-8.604-6.052-8.084-14.592   c0,0,3.433,0.778,6.58,3.417c-0.62-3.237-0.363-7.977,4.601-11.931c0,0,4.563,8.074-2.101,14.629   c0.579,0.816,1.084,1.743,1.502,2.774c1.497-2.28,3.899-4.4,7.765-5.689c0,0,1.781,10.815-8.316,15.339   c-0.239,6.316-1.228,11.895-2.924,16.748c2.891-2.549,5.233-6.055,5.233-6.055c0-12.015,9.849-12.318,9.849-12.318   c1.839,13.714-8.301,14.269-8.301,14.269l-5.553,6.059c12.015-2.002,12.015,8.01,12.015,8.01   c-8.01,2.002-12.015-2.002-12.015-2.002l-4.332,2.226c7.683,0.224,10.339,7.786,10.339,7.786   c-9.657,1.609-16.717-0.659-19.12-1.613c-9.726,6.8-21.712,6.809-27.248,6.809v-2.003L255.652,292.859L255.652,292.859z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M222.211,205.562c-7.042,4.513-13.25,10.26-18.253,17.044c2.149,1.585,4.298,3.169,6.447,4.754  c4.414-5.987,9.891-11.059,16.104-15.044L222.211,205.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B71"
    },
    d: "M256.023,257.626h28.034v16.02c0,4.424-3.586,8.01-8.01,8.01h-12.015c-3.291,0-6.185,1.609-8.01,4.06  v-28.09H256.023z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F64B9"
    },
    points: "262.03,239.604 262.03,217.577 292.067,217.577 284.057,225.587 284.057,247.614   262.03,247.614 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.05,
    y: 247.61,
    style: {
      fill: "#F5F5F5"
    },
    width: 10.01,
    height: 10.01
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B71"
    },
    d: "M256.023,257.626h-28.035v16.02c0,4.424,3.586,8.01,8.01,8.01h12.015c3.291,0,6.185,1.609,8.01,4.06  V257.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M251.016,282.14c1.997,0.639,3.721,1.882,4.96,3.521h0.092c1.239-1.64,2.963-2.882,4.96-3.521  v-16.503h-10.012L251.016,282.14L251.016,282.14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F64B9"
    },
    points: "250.015,239.604 250.015,217.577 219.978,217.577 227.988,225.587 227.988,247.614   250.015,247.614 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.99,
    y: 247.61,
    style: {
      fill: "#F5F5F5"
    },
    width: 10.01,
    height: 10.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "238,227.589 238,233.597 244.008,237.602 244.008,233.597 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "244.008,233.597 244.008,239.604 252.018,243.609 252.018,241.607 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "274.045,227.589 274.045,233.597 268.037,237.602 268.037,233.597 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "268.037,233.597 268.037,239.604 260.028,243.609 260.028,241.607 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M268.107,271.644h-24.159c-5.491,0-9.943-4.483-9.943-10.012V230.66l22.17,14.951l21.876-14.951  v30.971C278.05,267.161,273.598,271.644,268.107,271.644z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "242.005,235.599 233.996,229.592 233.996,251.619 242.005,255.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "270.04,235.599 278.05,229.592 278.05,251.619 270.04,255.624  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.01,
    y: 255.62,
    style: {
      fill: "#41479B"
    },
    width: 24.03,
    height: 10.01
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "244.008,237.602 256.023,243.609 268.037,237.602 268.037,255.624 244.008,255.624 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M265.034,239.495v20.134c0,1.656-1.347,3.004-3.004,3.004h-12.015c-1.656,0-3.004-1.347-3.004-3.004   v-20.052l-6.007-4.023v24.075c0,4.969,4.042,9.011,9.011,9.011h12.015c4.969,0,9.011-4.042,9.011-9.011v-24.211L265.034,239.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M267.131,253.483c-3.373,0.303-7.17,0.643-11.108,2.014c-3.938-1.371-7.735-1.711-11.108-2.014   c-5.644-0.507-8.993-1.001-10.91-4.405v5.78c2.943,1.914,6.672,2.266,10.551,2.615c3.482,0.313,7.081,0.636,10.758,2.028   l0.709,0.268l0.709-0.268c3.677-1.392,7.277-1.715,10.758-2.028c3.882-0.349,7.616-0.695,10.56-2.611v-5.797   C276.134,252.481,272.783,252.974,267.131,253.483z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "260.028,234.598 257.024,234.598 257.024,231.594 255.021,231.594 255.021,234.598   252.018,234.598 252.018,236.601 255.021,236.601 255.021,245.612 257.024,245.612 257.024,236.601 260.028,236.601 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.855,
    y: 222.407,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -94.1192 242.4742)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "233.53,222.756 235.729,227.155 237.929,224.956 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.331,
    y: 220.727,
    transform: "matrix(0.8083 -0.5888 0.5888 0.8083 -89.7223 190.7859)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "238.031,219.342 239.521,224.03 242.035,222.198 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.863,
    y: 224.511,
    transform: "matrix(0.5725 -0.8199 0.8199 0.5725 -90.1229 301.0583)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "229.61,227.164 232.546,231.111 234.326,228.561 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.628,
    y: 222.416,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 288.7129 589.3048)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "278.506,222.756 276.306,227.155 274.107,224.956 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.149,
    y: 220.723,
    transform: "matrix(-0.8083 -0.5888 0.5888 -0.8083 339.969 577.0277)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "274.004,219.342 272.514,224.03 270,222.198 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.63,
    y: 224.516,
    transform: "matrix(-0.5725 -0.8199 0.8199 -0.5725 227.7889 592.6859)",
    style: {
      fill: "#464655"
    },
    width: 1.555,
    height: 24.885
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "282.425,227.164 279.49,231.111 277.709,228.561 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M255.006,281.087c0,0-7.744-8.317-6.242-15.951c1.208-6.14,4.873-12.909,7.741-14.556  c0,0,4.056-0.25,3.039,3.273s-2.255,4.432-1.894,7.904C258.275,267.764,259.246,274.886,255.006,281.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M257.356,250.622c-0.484-0.064-0.852-0.043-0.852-0.043c-2.868,1.648-6.533,8.416-7.741,14.556  c-0.683,3.473,0.55,7.08,2.095,9.988C249.881,262.534,253.556,258.068,257.356,250.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M257.65,261.757c-0.362-3.472,0.876-4.38,1.894-7.904c0.712-2.466-1.058-3.082-2.187-3.231  c0,0-2.585,5.94-2.752,9.924c-0.147,3.506,0.751,17.772,0.402,20.54C259.246,274.886,258.275,267.764,257.65,261.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F0F0"
    },
    d: "M252.396,253.593c1.614-1.572,3.882-2.277,6.103-1.896c-1.053-3.39-2.107-6.781-3.16-10.171  c-2.22-0.381-4.489,0.324-6.103,1.896C250.289,246.812,251.343,250.203,252.396,253.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.499,251.697c1.614-1.572,3.882-2.277,6.103-1.896c-1.053-3.39-2.107-6.781-3.16-10.171  c-2.22-0.381-4.489,0.324-6.103,1.896C256.392,244.916,257.445,248.307,258.499,251.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F64B9"
    },
    d: "M246.874,207.699c-10.87-0.251-21.607,2.422-31.091,7.74c-1.306-2.329-2.612-4.658-3.917-6.987  c10.735-6.019,22.889-9.044,35.193-8.761C246.997,202.36,246.936,205.029,246.874,207.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M289.834,205.562c7.042,4.513,13.25,10.26,18.253,17.044c-2.149,1.585-4.298,3.169-6.447,4.754  c-4.414-5.987-9.891-11.059-16.104-15.044L289.834,205.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F64B9"
    },
    d: "M265.171,207.699c10.87-0.251,21.607,2.422,31.091,7.74c1.306-2.329,2.612-4.658,3.917-6.987  c-10.735-6.019-22.889-9.044-35.193-8.761C265.048,202.36,265.109,205.029,265.171,207.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M272.042,205.562c-10.487-2.869-21.552-2.869-32.039,0c-0.704-2.575-1.409-5.151-2.114-7.726  c11.871-3.247,24.396-3.247,36.267,0C273.451,200.411,272.747,202.987,272.042,205.562z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B71"
    },
    d: "M229.186,295.312c-8.644,2.257-17.092,5.302-25.227,9.135c1.138,2.415,2.276,4.83,3.414,7.246   c7.85-3.7,16.011-6.62,24.36-8.765L229.186,295.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B71"
    },
    d: "M282.86,295.312c8.644,2.257,17.092,5.302,25.227,9.135c-1.138,2.415-2.276,4.83-3.414,7.246   c-7.85-3.7-16.011-6.62-24.36-8.765L282.86,295.312z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M288.235,301.508c-21.06-5.056-43.018-5.056-64.079,0c-0.623-2.596-1.247-5.192-1.87-7.789   c22.289-5.351,45.529-5.351,67.819,0C289.481,296.315,288.858,298.911,288.235,301.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M256.023,303.683l-5.522,1.38c-1.264,0.316-2.488-0.64-2.488-1.943v-2.88   c0-1.303,1.224-2.259,2.488-1.943l5.522,1.38V303.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M256.023,299.678l5.522-1.38c1.264-0.316,2.488,0.64,2.488,1.943v2.88   c0,1.303-1.224,2.259-2.488,1.943l-5.522-1.38V299.678z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B71"
    },
    d: "M256.452,303.683h-0.859c-0.869,0-1.573-0.704-1.573-1.573v-0.859c0-0.869,0.704-1.573,1.573-1.573  h0.859c0.869,0,1.573,0.704,1.573,1.573v0.859C258.025,302.979,257.321,303.683,256.452,303.683z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/DO.7cb5af8b61899076843a54c133fb8e89.svg";
export { ForwardRef as ReactComponent };